<template>
  <div>
    <div v-if="isDetail">
      <Detail ref="Detail" @back="isDetail = false" @changeStatus="getStatus(1)"></Detail>
    </div>
    <page-header-wrapper v-else>
      <a-card :bordered="false">
        <!-- 条件搜索 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" labelAlign="right">
            <a-row :gutter="48">
              <a-col :md="6" :sm="24">
                <a-form-item label="派单编号">
                  <a-input v-model="queryParam.orderNo" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24" v-if="(userType == 0 || userType == 1) && !regionId">
                <a-form-item label="区域">
                  <a-select show-search :allowClear="true" v-model="queryParam.regionId" placeholder="请选择"
                    option-filter-prop="children" :filter-option="filterOption">
                    <a-select-option v-for="d in listRegion" :key="d.id">{{ d.name }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="业主姓名">
                  <a-input @keyup.enter="handleQuery" v-model="queryParam.ownerName" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="业主电话">
                  <a-input @keyup.enter="handleQuery" v-model="queryParam.ownerPhone" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="验收员名称">
                  <a-input @keyup.enter="handleQuery" v-model="queryParam.pressureTestName" placeholder="请输入"
                    allow-clear />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24" v-if="advanced">
                <a-form-item label="验收员电话">
                  <a-input @keyup.enter="handleQuery" v-model="queryParam.pressureTestUserPhone" placeholder="请输入"
                    allow-clear />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24" v-if="advanced">
                <a-form-item label="经销商">
                  <a-input placeholder="请选择经销商" v-model="selectedAgentName" read-only style="width: 100%" allow-clear
                    @click="openAgentModal('agent')" @clear="handleClearAgent">
                    <a-icon slot="suffix" type="search" @click="openAgentModal('agent')" />
                  </a-input>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24" v-if="advanced">
                <a-form-item label="分销商">
                  <a-input placeholder="请选择分销商" v-model="selectedDistributorName" read-only style="width: 100%"
                    allow-clear @click="openAgentModal('distributor')" @clear="handleClearDistributor">
                    <a-icon slot="suffix" type="search" @click="openAgentModal('distributor')" />
                  </a-input>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24" v-if="advanced">
                <a-form-item label="预约姓名">
                  <a-input @keyup.enter="handleQuery" v-model="queryParam.reservationName" placeholder="请输入"
                    allow-clear />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24" v-if="advanced">
                <a-form-item label="预约手机号">
                  <a-input @keyup.enter="handleQuery" v-model="queryParam.reservationPhone" placeholder="请输入"
                    allow-clear />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24" v-if="advanced && (status == 5 || status == 7)">
                <a-form-item label="水工姓名">
                  <a-input @keyup.enter="handleQuery" v-model="queryParam.waterName" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24" v-if="advanced && (status == 5 || status == 7)">
                <a-form-item label="水工电话">
                  <a-input @keyup.enter="handleQuery" v-model="queryParam.waterPhone" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24" v-if="advanced && !isOperate">
                <a-form-item label="订单状态">
                  <a-select show-search :allowClear="true" v-model="queryParam.statusVlaue" placeholder="请选择"
                    option-filter-prop="children" :filter-option="filterOption" @change="handleValue">
                    <a-select-option :value="3">待接单</a-select-option>
                    <a-select-option :value="1">待派单</a-select-option>
                    <a-select-option :value="4">待试压</a-select-option>
                    <a-select-option :value="5">待审核</a-select-option>
                    <a-select-option :value="20">已驳回</a-select-option>
                    <a-select-option :value="7">已完成</a-select-option>
                    <a-select-option :value="2">已拒绝</a-select-option>
                    <a-select-option :value="8">已作废</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24" v-if="advanced">
                <a-form-item label="订单类型">
                  <a-select show-search :allowClear="true" v-model="queryParam.orderType" placeholder="请选择"
                    option-filter-prop="children" :filter-option="filterOption">
                    <a-select-option :value="0">普通服务单</a-select-option>
                    <a-select-option :value="1">预约服务单</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <template v-if="advanced">
                <a-col :md="6" :sm="24">
                  <a-form-item label="小区名称">
                    <a-input v-model="queryParam.minAreaName" placeholder="请输入" allow-clear />
                  </a-form-item>
                </a-col>
              </template>
              <template v-if="advanced">
                <a-col :md="6" :sm="24">
                  <a-form-item label="详细地址">
                    <a-input v-model="queryParam.ownerAddress" placeholder="请输入" allow-clear />
                  </a-form-item>
                </a-col>
              </template>
              <!-- <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="项目经理">
                  <a-input v-model="queryParam.proBane" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
            </template>
            <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="项目经理电话">
                  <a-input v-model="queryParam.proPhone" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
            </template> -->
              <template v-if="advanced">
                <a-col :md="12" :sm="24">
                  <a-form-item label="省市区">
                    <v-distpicker :province="queryParam.province" :city="queryParam.city" :area="queryParam.area"
                      @province="onChangeProvince" @city="onChangeCity" @area="onChangeArea">
                    </v-distpicker>
                  </a-form-item>
                </a-col>
              </template>
              <!-- <template v-if="advanced">
                <a-col :md="6" :sm="24">
                  <a-form-item label="市">
                    <a-input v-model="queryParam.city" placeholder="请输入" allow-clear />
                  </a-form-item>
                </a-col>
              </template>
              <template v-if="advanced">
                <a-col :md="6" :sm="24">
                  <a-form-item label="区">
                    <a-input v-model="queryParam.area" placeholder="请输入" allow-clear />
                  </a-form-item>
                </a-col>
              </template> -->
              <template v-if="advanced">
                <a-col :md="8" :sm="24">
                  <a-form-item label="时间范围">
                    <a-range-picker v-model="value" format="YYYY-MM-DD" :placeholder="['开始时间', '结束时间']"
                      @change="onChange" />
                    <!-- :show-time="{ format: 'HH:mm:ss' }" -->
                  </a-form-item>
                </a-col>
              </template>

              <!-- <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="租户编码">
                  <a-input v-model="queryParam.code" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
            </template>
            <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="租户编码">
                  <a-input v-model="queryParam.code" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
            </template>
            <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="信用代码">
                  <a-input v-model="queryParam.socialCreditCode" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
            </template>
            <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="联系人">
                  <a-input v-model="queryParam.contacts" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
            </template>
            <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="电话">
                  <a-input v-model="queryParam.mobile" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
            </template>
            <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="状态">
                  <a-select placeholder="请选择" v-model="queryParam.status" style="width: 100%" allow-clear>
                    <a-select-option :value="0"> 正常 </a-select-option>
                    <a-select-option :value="1"> 异常关闭 </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </template>
            <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="租户类型">
                  <a-select placeholder="请选择" v-model="queryParam.type" style="width: 100%" allow-clear>
                    <a-select-option :value="1"> 厂商 </a-select-option>
                    <a-select-option :value="2"> 经销商 </a-select-option>
                    <a-select-option :value="3"> 分经销商 </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </template>
            <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="营业状态">
                  <a-select placeholder="请选择" v-model="queryParam.tradeStatus" style="width: 100%" allow-clear>
                    <a-select-option :value="0"> 营业中 </a-select-option>
                    <a-select-option :value="10"> 维修升级中 </a-select-option>
                    <a-select-option :value="60"> 暂停营业 </a-select-option>
                    <a-select-option :value="70"> 隐藏 </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </template>

            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="时间范围">
                  <a-range-picker format="YYYY-MM-DD" :placeholder="['开始时间', '结束时间']" @change="onChange" />
                </a-form-item>
              </a-col>
            </template> -->
              <a-col :md="(!advanced && 6) || 24" :sm="24">
                <span class="table-page-search-submitButtons"
                  :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}">
                  <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                  <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                  <a @click="toggleAdvanced" style="margin-left: 8px">
                    {{ advanced ? '收起' : '展开' }}
                    <a-icon :type="advanced ? 'up' : 'down'" />
                  </a>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <!-- 操作 -->
        <div class="table-operations">
          <template v-if="isOperate">
            <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['abm-fix:order:add']"
              v-if="queryParam.status == 1 || queryParam.status == 3">
              <a-icon type="plus" />新增
            </a-button>
            <!-- <a-button
          type="primary"
          :disabled="single"
          @click="$refs.createForm.handleUpdate(undefined, ids)"
          v-hasPermi="['abm-fix:dev:edit']"
        >
          <a-icon type="edit" />修改
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['abm-fix:model:remove']">
          <a-icon type="delete" />删除
        </a-button> -->
            <a-button type="primary" :disabled="queryParam.subBeginTime && queryParam.subEndTime ? fasle : true"
              @click="handleExport" v-hasPermi="['abm-fix:order:export']">
              <a-icon type="download" />导出
            </a-button>
          </template>

          <table-setting :style="{ float: 'right' }" :table-size.sync="tableSize" v-model="columns"
            :refresh-loading="loading"></table-setting>
        </div>
        <examineDetail ref="examineDetail"></examineDetail>
        <!-- 增加修改 -->
        <create-form ref="createForm" :statusOptions="dict.type['sys_enable_disable']" @ok="getList" />
        <!-- 审核 -->
        <Examine ref="Examine" @ok="getList" @changeStatus="getStatus"></Examine>
        <a-table :key="tableKey" :loading="loading" :size="tableSize" ref="tableRef" rowKey="id" :columns="columns"
          :data-source="list" :pagination="false" :bordered="tableBordered" :customRow="(record) => ({
            style: {
              backgroundColor:
                record.pressType == 1 &&
                  ((record.acceptStatus == 1 && record.status == 5) || (record.acceptStatus == 3 && record.status == 7))
                  ? 'rgba(255,0,0,0.1)'
                  : 'inherit',
            },
          })
            ">
          <span slot="status" slot-scope="text, record">
            <dict-tag :options="dict.type['sys_enable_disable']" :value="record.status" />
          </span>
          <span slot="tenantFirmName" slot-scope="text, record">
            <span v-if="record.tenantFirmId !== record.tenantAgentId">{{ record.tenantFirmName }}</span>
            <span v-else>--</span>
          </span>

          <span slot="tenantAgentName" slot-scope="text, record">
            <span v-if="record.tenantAgentId == record.tenantId">{{ record.tenantName }}</span>
            <span v-else>{{ record.tenantAgentName }}</span>
          </span>
          <span slot="tenantName" slot-scope="text, record">
            <span v-if="record.tenantAgentId !== record.tenantId && record.tenantFirmId !== record.tenantId">{{
              record.tenantName
              }}</span>
            <span v-else></span>
          </span>
          <span slot="pressureResult" slot-scope="text, record">
            <span>合格</span>
          </span>
          <span slot="ownerEvaluate" slot-scope="text, record">
            <span>{{
              record.ownerEvaluate == 1
                ? '非常满意'
                : record.ownerEvaluate == 2
                  ? '满意'
                  : record.ownerEvaluate == 3
                    ? '不满意'
                    : ''
            }}</span>
          </span>
          <span slot="city" slot-scope="text, record">{{ record.province }} {{ record.city }}{{ record.area }} </span>
          <span slot="subTime" slot-scope="text, record">
            {{ parseTime(record.subTime) }}
          </span>
          <span slot="status" slot-scope="text, record">
            <!-- {{ parseTime(record.createTime) }} -->
            <a-tag color="red" v-if="record.status"> 禁用 </a-tag>
            <a-tag color="green" v-else> 启用 </a-tag>
          </span>
          <!-- 业主信息 -->
          <div slot="ownerName" slot-scope="text, record">
            {{ record.ownerName }}
            <p>{{ record.ownerPhone }}</p>
          </div>
          <!-- 验收员信息 -->
          <div slot="pressureTestName" slot-scope="text, record">
            {{ record.pressureTestName }}
            <p>{{ record.pressureTestUserPhone }}</p>
          </div>

          <span slot="operation" slot-scope="text, record">

            <!-- <a @click="$refs.Examine.init(record, 4)" v-hasPermi="['abm-fix:order:edit01']" v-if="record.status == 1">
              派单
            </a>
            <a-divider type="vertical" v-hasPermi="['abm-fix:order:edit']" v-if="record.status == 1" />
            <a
              @click="$refs.createForm.handleUpdate(record, undefined)"
              v-hasPermi="['abm-fix:order:edit']"
              v-if="record.status !== 8 && record.status !== 5"
            >
              修改
            </a>
            <a-divider
              type="vertical"
              v-hasPermi="['abm-fix:order:void']"
              v-if="record.status !== 8 && record.status !== 5"
            /> -->

            <a-divider type="vertical" v-hasPermi="['abm-fix:order:edit']"
              v-if="(record.status == 1 || record.status == 2) && record.tenantId === tenantId" />
            <a @click="handleDetail(record)"> 详情 </a>
            <a-divider type="vertical" v-hasPermi="['abm-fix:order:query']" v-if="
              ((record.status == 1 || record.status == 2) && record.tenantId === userTentant.tenantId) ||
              (record.acceptStatus == 1 &&
                record.status !== 8 &&
                ((record.openAgentAudit && userType == 2) || userType == 1 || userType == 0)) ||
              (record.acceptStatus == 3 && record.status == 7) ||
              record.status !== 8
            " />
            <a-dropdown v-hasPermi="['abm-fix:order:query']">
              <a class="ant-dropdown-link" @click="(e) => e.preventDefault()" v-if="
                ((record.status == 1 || record.status == 2) && record.tenantId === userTentant.tenantId) ||
                (record.acceptStatus == 1 &&
                  record.status !== 8 &&
                  ((record.openAgentAudit && userType == 2) || userType == 1 || userType == 0)) ||
                (record.acceptStatus == 3 && record.status == 7) ||
                record.status !== 8
              ">
                <a-icon type="double-right" />
                更多
              </a>
              <a-menu slot="overlay">
                <a-menu-item v-hasPermi="['abm-fix:order:query']">
                  <a @click="$refs.Examine.init(record, 4)" v-hasPermi="['abm-fix:order:edit01']"
                    v-if="(record.status == 1 || record.status == 2) && record.tenantId === userTentant.tenantId">
                    派单
                  </a>
                </a-menu-item>
                <!-- <a-menu-item v-hasPermi="['abm-fix:order:query']">
                  <a
                    @click="$refs.Examine.init(record, 4)"
                    v-hasPermi="['abm-fix:order:edit01']"
                    v-if="record.status == 1 && record.tenantId === tenantId"
                  >
                    派单
                  </a>
                </a-menu-item> -->
                <a-menu-item v-hasPermi="['abm-fix:order:edit03']" v-if="
                  record.acceptStatus == 1 &&
                  record.status !== 8 &&
                  ((record.openAgentAudit && userType == 2) || userType == 1 || userType == 0)
                ">
                  <a @click="$refs.Examine.init(record, record.acceptStatus)"> 审核 </a>
                </a-menu-item>
                <!-- <a-menu-item v-hasPermi="['abm-fix:order:edit03']" v-if="record.acceptStatus == 1">
                  <a @click="$refs.Examine.init(record, 3)"> 修改积分 </a>
                </a-menu-item> -->
                <a-menu-item v-hasPermi="['abm-fix:order:void']" v-if="record.status !== 8">
                  <a @click="handleDelete(record)"> 作废订单 </a>
                </a-menu-item>
                <!-- <a-menu-item v-hasPermi="['monitor:job:query']">
                  <a @click="$refs.Examine.init(record, 10)"> 配置Vr信息 </a>
                </a-menu-item> -->
                <a-menu-item v-if="record.status == 7 && record.acceptStatus == 3">
                  <a @click="handleLookDown(record, 0)"> 预览报告 </a>
                </a-menu-item>
                <a-menu-item v-if="record.status == 7 && record.acceptStatus == 3">
                  <a @click="handleRegenerate(record, 1)"> 重新生成报告 </a>
                </a-menu-item>
                <a-menu-item v-if="record.acceptStatus == 3 && record.status == 7"
                  v-hasPermi="['b5c031cc16e51df9b3ce3cea4589c50f:0:1']">
                  <a @click="handleSendSms(record)"> 重新短信 </a>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </span>
        </a-table>
        <!-- 分页 -->
        <a-pagination class="ant-table-pagination" show-size-changer show-quick-jumper :current="queryParam.pageNum"
          :total="total" :page-size="queryParam.pageSize" :showTotal="(total) => `共 ${total} 条`"
          @showSizeChange="onShowSizeChange" @change="changeSize" />

        <a-modal :title="currentSelectType == 'agent' ? '选择经销商' : '选择分销商'" :width="isMobile ? '95vw' : '1200px'"
          :visible="showAgentModal" @ok="handleAgentSelect" @cancel="showAgentModal = false"
          :confirmLoading="agentModalLoading" :bodyStyle="{ height: '70vh', overflow: 'auto' }">
          <div class="table-page-search-wrapper">
            <a-form layout="inline" labelAlign="right">
              <a-row :gutter="48">
                <a-col :md="6" :sm="24">
                  <a-form-item :label="currentSelectType == 'agent' ? '经销商名称' : '分销商名称'">
                    <a-input v-model="agentQuery.name" placeholder="请输入" allow-clear />
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item label="联系人">
                    <a-input v-model="agentQuery.contacts" placeholder="请输入" allow-clear />
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item label="状态">
                    <a-select placeholder="请选择" v-model="agentQuery.status" style="width: 100%" allow-clear>
                      <a-select-option :value="0"> 正常 </a-select-option>
                      <a-select-option :value="1"> 异常关闭 </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <span class="table-page-search-submitButtons">
                    <a-button type="primary" @click="handleAgentQuery"><a-icon type="search" />查询</a-button>
                    <a-button style="margin-left: 8px" @click="resetAgentQuery"><a-icon type="redo" />重置</a-button>
                  </span>
                </a-col>
              </a-row>
            </a-form>
          </div>
          <a-table :loading="agentLoading" rowKey="id" :columns="agentColumns" :data-source="agentList"
            :pagination="agentPagination" @change="handleAgentTableChange" :row-selection="{
              type: 'radio',
              selectedRowKeys: currentSelectType === 'agent' ? selectedAgentKeys : selectedDistributorKeys,
              onChange: onAgentSelectChange,
            }" :scroll="{ x: 800 }" @rowClick="handleAgentRowClick" :customRow="customAgentRow">
            <span slot="name" slot-scope="text, record">
              <a-tooltip placement="topLeft" :title="record.name">
                <span class="text-ellipsis">{{ record.name }}</span>
              </a-tooltip>
            </span>
            <span slot="contacts" slot-scope="text, record">
              <a-tooltip placement="topLeft" :title="record.contacts">
                <span class="text-ellipsis">{{ record.contacts }}</span>
              </a-tooltip>
            </span>
            <span slot="mobile" slot-scope="text, record">
              <a-tooltip placement="topLeft" :title="record.mobile">
                <span class="text-ellipsis">{{ record.mobile }}</span>
              </a-tooltip>
            </span>
            <span slot="status" slot-scope="text, record">
              <a-tag :color="record.status === 0 ? 'green' : 'red'">
                {{ record.status === 0 ? '正常' : '异常关闭' }}
              </a-tag>
            </span>

          </a-table>
        </a-modal>
      </a-card>
    </page-header-wrapper>
  </div>
</template>

<script>
import {
  fetchList,
  statusCount,
  delObj,
  statusObj,
  orderVoid,
  sendSms,
  acceptanceReport,
  recordPage,
} from '@/api/pressure/dispatch'
import { regionList } from '@/api/pressure/region'
import CreateForm from './modules/CreateForm'
import Detail from './modules/detail'
import examineDetail from './modules/examineDetail'
import Examine from './modules/examine'
import { listTenant } from '@/api/system/tenant'
import { tableMixin } from '@/store/table-mixin'
import moment from 'moment'
import { mapGetters } from 'vuex'
import { isDate } from 'lodash'
import { name } from 'file-loader'
export default {
  name: 'Post',
  components: {
    CreateForm,
    Detail,
    Examine,
    examineDetail,
  },
  mixins: [tableMixin],
  dicts: ['sys_enable_disable'],
  props: {
    isOperate: {
      type: Boolean,
      default: true,
    },
    firmId: {
      type: [String, Number],
    },
    tenantId: {
      type: [String, Number],
    },
    tenantFirmId: {
      type: [String, Number],
    },
    regionId: {
      type: [String, Number],
    },
  },
  data() {
    return {
      list: [],
      value: [],
      isDetail: false,
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        postCode: undefined,
        postName: undefined,
        status: undefined,
        regionId: undefined,
        orderType: undefined,
        tenantAgentId: undefined,
        tenantId: undefined,
      },
      columns: [
        {
          title: '派单编号',
          dataIndex: 'orderNo',
          align: 'center',
          // fixed: 'left',
          width: 110,
        },
        {
          title: '企业品牌',
          dataIndex: 'tenantFirmName',
          align: 'center',
          width: 130,
          visible: false,
        },
        {
          title: '经销商',
          dataIndex: 'tenantAgentName',
          scopedSlots: { customRender: 'tenantAgentName' },
          align: 'center',
          width: 120,
          visible: false,
        },
        {
          title: '分销商',
          dataIndex: 'tenantName',
          scopedSlots: { customRender: 'tenantName' },
          align: 'center',
          width: 90,
          visible: false,
        },
        // {
        //   title: '省市区',
        //   width: 100,
        //   dataIndex: 'province',
        //   ellipsis: true,
        //   align: 'center',
        //   visible: false,
        // },
        {
          title: '省市区',
          dataIndex: 'city',
          scopedSlots: { customRender: 'city' },
          // ellipsis: true,
          width: 130,
          align: 'center',
        },
        {
          title: '业主信息',
          dataIndex: 'ownerName',
          // scopedSlots: { customRender: 'ownerName' },
          scopedSlots: { customRender: 'ownerName' },
          // ellipsis: true,
          width: 80,
          align: 'center',
        },
        // {
        //   title: '业主电话',
        //   dataIndex: 'ownerPhone',
        //   ellipsis: true,
        //   width: 95,
        //   align: 'center',
        // },
        {
          title: '验收员信息',
          dataIndex: 'pressureTestName',
          scopedSlots: { customRender: 'pressureTestName' },
          width: 80,
          // ellipsis: true,
          align: 'center',
        },
        // {
        //   title: '验收员电话',
        //   dataIndex: 'pressureTestUserPhone',
        //   width: 95,
        //   ellipsis: true,
        //   align: 'center',
        // },
        // {
        //   title: '派单人',
        //   dataIndex: 'proBane',
        //   ellipsis: true,
        //   align: 'center',
        // },
        // {
        //   title: '派单人手机号',
        //   dataIndex: 'proPhone',
        //   ellipsis: true,
        //   align: 'center',
        // },
        {
          title: '测压结果',
          dataIndex: 'pressureResult',
          scopedSlots: { customRender: 'pressureResult' },
          width: 65,
          // ellipsis: true,
          align: 'center',
        },
        // {
        //   title: '评价',
        //   dataIndex: 'ownerEvaluate',
        //   scopedSlots: { customRender: 'ownerEvaluate' },
        //   ellipsis: true,
        //   width: 90,
        //   align: 'center',
        // },
        // {
        //   title: '设备编号',
        //   dataIndex: 'devCode',
        //   ellipsis: true,
        //   align: 'center',
        // },
        // {
        //   title: '租户简称',
        //   dataIndex: 'referredName',
        //   align: 'center',
        // },
        {
          title: '建单时间',
          dataIndex: 'createTime',
          width: 75,
          align: 'center',
        },
        {
          title: '预约时间',
          dataIndex: 'reservationTime',
          width: 80,
          align: 'center',
        },
        {
          title: '完成时间',
          dataIndex: 'subTime',
          width: 75,
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 100,
          scopedSlots: { customRender: 'operation' },
          align: 'center',
          // fixed: 'right',
        },
      ],
      orderType: 0,
      status: 1,
      agentList: [],
      listRegion: [],
      tableKey: '',
      // 经销商选择相关
      selectedAgentName: '',
      selectedAgentKeys: [],
      selectedAgent: null,
      // 分销商选择相关
      selectedDistributorName: '',
      selectedDistributorKeys: [],
      selectedDistributor: null,
      // 模态框相关
      showAgentModal: false,
      currentSelectType: 'agent', // 'agent' 或 'distributor'，标识当前选择的是经销商还是分销商
      agentModalLoading: false,
      agentLoading: false,
      agentPagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total) => `共 ${total} 条`,
      },
      agentQuery: {
        pageNum: 1,
        pageSize: 10,
        name: null,
        contacts: null,
        status: null,
        type: '2', // 经销商
      },
      agentColumns: [
        {
          title: '名称',
          dataIndex: 'name',
          key: 'name',
          align: 'center',
          width: '200px',
          scopedSlots: { customRender: 'name' },
        },
        {
          title: '联系人',
          dataIndex: 'contacts',
          align: 'center',
          width: '120px',
          scopedSlots: { customRender: 'contacts' },
        },
        {
          title: '联系电话',
          dataIndex: 'mobile',
          align: 'center',
          width: '130px',
          scopedSlots: { customRender: 'mobile' },
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          align: 'center',
          width: '100px',
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          align: 'center',
          width: '150px',
          scopedSlots: { customRender: 'createTime' },
        },
      ],
    }
  },
  filters: {},
  mounted() {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },

  created() {
    this.tableKey = Date.now()
    if (!this.isOperate) {
      this.columns.pop()
    }
    // this.$route.meta.title = this.$route.meta.title + '(1)'
    const name = this.$route.name
    if (name === 'DispatchOne') {
      // 预约订单
      this.queryParam.orderType = 1
      this.orderType = 1
    } else if (name === 'DispatchTwo') {
      // 待确认
      this.queryParam.status = 0
      this.status = 0
    } else if (name === 'DispatchThree') {
      // 待派单
      this.queryParam.status = 1
      this.status = 1
      this.columns.splice(-2, 1)
      this.columns.splice(-4, 1)
      this.columns.splice(-4, 1)
    } else if (name === 'DispatchFour') {
      // 派单拒绝
      this.queryParam.status = 2
      this.status = 2
      this.columns.splice(-2, 1)
      this.columns.splice(-4, 1)
      this.columns.splice(-4, 1)
    } else if (name === 'DispatchFive') {
      // 待接单
      this.queryParam.status = 3
      this.status = 3
      this.columns.splice(-2, 1)
      this.columns.splice(-4, 1)
      this.columns.splice(-4, 1)
    } else if (name === 'DispatchSix') {
      // 已受理
      this.queryParam.status = 4
      this.status = 4
      this.columns.splice(-2, 1)
      this.columns.splice(-4, 1)
      this.columns.splice(-4, 1)
    } else if (name === 'DispatchSeven') {
      // 已提交审核
      this.queryParam.status = 5
      this.queryParam.acceptStatus = 1
      this.status = 5
    } else if (name === 'DispatchEight') {
      // 已完成
      this.queryParam.status = 7
      this.queryParam.acceptStatus = 3

      this.status = 7
    } else if (name === 'Ten') {
      // 打回
      this.queryParam.acceptStatus = 2
      this.queryParam.status = 5
      // this.status = 7
    } else if (name === 'DispatchNine') {
      // 订单作废
      this.queryParam.status = 8
      this.status = 8
    }
    this.queryParam.tenantId = this.tenantId
    this.queryParam.tenantFirmId = this.tenantFirmId
    this.queryParam.regionId = this.regionId
    // if (this.tenantId || this.regionId || this.tenantFirmId) {
    //   this.queryParam.status = 7
    // }
    this.getList()

    if (this.userType == 0 || this.userType == 1) {
      this.getQu()
      this.getAgentList()
    }
    if (this.userType === 1) {
      this.columns.splice(1, 1)
    } else if (this.userType == 2) {
      this.columns.splice(2, 1)
    }
  },
  computed: {
    userType() {
      return this.$store.state.user.userTentant.type
    },
    ...mapGetters(['userTentant', 'infoUser', 'isMobile']),
  },
  watch: {
    // 监听经销商/分销商模态框显示状态
    showAgentModal(newVal) {
      if (newVal) {
        // 打开模态框时，初始化选中状态
        this.$nextTick(() => {
          this.initSelectedAgent()
        })
      }
    },
    // 监听数据列表变化，初始化选中状态
    agentList(newList) {
      if (this.showAgentModal && newList.length > 0) {
        this.$nextTick(() => {
          this.initSelectedAgent()
        })
      }
    },
  },
  // watch: {
  //   tenantFirmId: {
  //     handler(newVal, oldVal) {
  //       console.log('User data changed:', newVal)
  //       this.getList()
  //     },
  //     deep: true,
  //   },
  // },
  methods: {
    // 打开选择模态框
    openAgentModal(type) {
      this.currentSelectType = type
      // 根据选择类型设置默认的查询类型
      if (type === 'agent') {
        this.agentQuery.type = '2' // 经销商
        this.selectedAgentKeys = []
        this.selectedAgent = null
      } else {
        this.agentQuery.type = '3' // 分销商
        this.selectedDistributorKeys = []
        this.selectedDistributor = null
      }
      this.agentQuery.pageNum = 1
      this.showAgentModal = true
      // 加载数据
      this.getAgentList()
    },
    // 租户类型切换
    handleAgentTypeChange(activeKey) {
      this.agentQuery.type = activeKey
      this.agentQuery.pageNum = 1
      // 切换类型时清空选中状态
      if (this.currentSelectType === 'agent') {
        this.selectedAgentKeys = []
        this.selectedAgent = null
      } else {
        this.selectedDistributorKeys = []
        this.selectedDistributor = null
      }
      this.getAgentList()
    },
    // 经销商/分销商选择相关方法
    getAgentList() {
      this.agentLoading = true
      listTenant(this.agentQuery)
        .then((res) => {
          if (res.code === '20001') {
            this.agentList = res.data.records
            this.agentPagination.total = res.data.total
            this.agentPagination.current = res.data.current

            // 初始化选中状态
            this.initSelectedAgent()
          }
          this.agentLoading = false
        })
        .catch(() => {
          this.agentLoading = false
        })
    },
    handleAgentQuery() {
      this.agentQuery.pageNum = 1
      this.getAgentList()
    },
    resetAgentQuery() {
      this.agentQuery = {
        pageNum: 1,
        pageSize: 10,
        name: null,
        contacts: null,
        status: null,
        type: this.agentQuery.type || '2', // 保持当前选择的类型
      }
      this.getAgentList()
    },
    handleAgentTableChange(pagination) {
      this.agentQuery.pageNum = pagination.current
      this.agentQuery.pageSize = pagination.pageSize
      this.getAgentList()
    },
    onAgentSelectChange(selectedRowKeys, selectedRows) {
      if (this.currentSelectType === 'agent') {
        this.selectedAgentKeys = selectedRowKeys
        this.selectedAgent = selectedRows[0] || null
      } else {
        this.selectedDistributorKeys = selectedRowKeys
        this.selectedDistributor = selectedRows[0] || null
      }
    },
    handleAgentSelect() {
      if (this.currentSelectType === 'agent') {
        if (!this.selectedAgent) {
          this.$message.warning('请选择一个经销商')
          return
        }
        this.queryParam.tenantAgentId = this.selectedAgent.id
        this.selectedAgentName = this.selectedAgent.name
      } else {
        if (!this.selectedDistributor) {
          this.$message.warning('请选择一个分销商')
          return
        }
        this.queryParam.tenantId = this.selectedDistributor.id
        this.selectedDistributorName = this.selectedDistributor.name
      }
      this.showAgentModal = false
    },
    handleAgentRowClick(record) {
      if (this.currentSelectType === 'agent') {
        this.selectedAgentKeys = [record.id]
        this.selectedAgent = record
        this.queryParam.tenantAgentId = record.id
        this.selectedAgentName = record.name
      } else {
        this.selectedDistributorKeys = [record.id]
        this.selectedDistributor = record
        this.queryParam.tenantId = record.id
        this.selectedDistributorName = record.name
      }
      this.showAgentModal = false
    },
    customAgentRow(record) {
      return {
        on: {
          click: () => {
            this.handleAgentRowClick(record)
          },
        },
        style: {
          cursor: 'pointer',
        },
      }
    },
    handleClearAgent() {
      this.queryParam.tenantAgentId = undefined
      this.selectedAgentName = ''
      this.selectedAgentKeys = []
      this.selectedAgent = null
    },
    handleClearDistributor() {
      this.queryParam.tenantId = undefined
      this.selectedDistributorName = ''
      this.selectedDistributorKeys = []
      this.selectedDistributor = null
    },
    // 初始化选中经销商/分销商状态
    initSelectedAgent() {
      if (this.currentSelectType === 'agent') {
        if (this.queryParam.tenantAgentId && this.agentList.length > 0) {
          const selected = this.agentList.find(item => item.id === this.queryParam.tenantAgentId)
          if (selected) {
            this.selectedAgentKeys = [this.queryParam.tenantAgentId]
            this.selectedAgent = selected
            this.selectedAgentName = selected.name
          } else {
            this.selectedAgentKeys = []
            this.selectedAgent = null
          }
        } else {
          this.selectedAgentKeys = []
          this.selectedAgent = null
        }
      } else {
        if (this.queryParam.tenantId && this.agentList.length > 0) {
          const selected = this.agentList.find(item => item.id === this.queryParam.tenantId)
          if (selected) {
            this.selectedDistributorKeys = [this.queryParam.tenantId]
            this.selectedDistributor = selected
            this.selectedDistributorName = selected.name
          } else {
            this.selectedDistributorKeys = []
            this.selectedDistributor = null
          }
        } else {
          this.selectedDistributorKeys = []
          this.selectedDistributor = null
        }
      }
    },
    // 查询各个状态
    getStatus(e) {
      statusCount().then((res) => {
        const date = res.data
        const name = this.$route.name
        if (name == 'DispatchFive') {
          // 待接单
          this.$route.meta.title = this.$route.meta.title.substring(0, 6) + '(' + date.pendingCount + ')'
        }
        if (name == 'DispatchThree') {
          // 待派单
          this.$route.meta.title = this.$route.meta.title.substring(0, 6) + '(' + date.toBeSentCount + ')'
        }
        if (name == 'DispatchSix') {
          // 待试压
          this.$route.meta.title = this.$route.meta.title.substring(0, 6) + '(' + date.toBePressedCount + ')'
        }
        if (name == 'DispatchSeven') {
          // 待审核
          this.$route.meta.title = this.$route.meta.title.substring(0, 6) + '(' + date.submittedCount + ')'
        }
        if (name == 'Ten') {
          // 已驳回
          this.$route.meta.title = this.$route.meta.title.substring(0, 6) + '(' + date.rejectedCount + ')'
        }
        if (name == 'DispatchFour') {
          // 已拒绝
          this.$route.meta.title = this.$route.meta.title.substring(0, 6) + '(' + date.declinedCount + ')'
        }
        if (name == 'DispatchEight') {
          // 已完成
          this.$route.meta.title = this.$route.meta.title.substring(0, 6) + '(' + date.completedCount + ')'
        }
        if (name == 'DispatchNine') {
          // 已作废
          this.$route.meta.title = this.$route.meta.title.substring(0, 6) + '(' + date.haveBeenCancelledCount + ')'
        }
        // const allRoutes = this.$router.options
        // console.log(allRoutes, '所有的路由信息') // 输出所有路由（包括动态添加的）
        // console.log(res.data, '顶顶顶顶吗')
      })
      if (e) {
        this.getList()
      }
    },
    // 点击跳转详情
    handleDetail(e) {
      this.isDetail = true
      this.$nextTick(() => {
        this.$refs.Detail.init(e, 1)
      })
    },
    handleResize() {
      this.$nextTick(() => {
        // 可能需要重新计算表格布局
        if (this.$refs.tableRef) {
          this.$refs.tableRef.doLayout()
        }
      })
    },
    //  状态变化
    handleValue(e) {
      if (e == 20) {
        this.queryParam.acceptStatus = 2
        this.queryParam.status = ''
      } else {
        this.queryParam.status = e
        if (e == 5) {
          this.queryParam.acceptStatus = 1
        } else {
          this.queryParam.acceptStatus = ''
        }
      }
    },
    // 点击确定
    onChange(e) {
      // console.log(e, '的点点滴滴')
      if (e.length) {
        this.queryParam.subBeginTime = moment(e[0]).startOf('day').format('YYYY-MM-DD HH:mm:ss')
        this.queryParam.subEndTime = moment(e[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss')
      } else {
        this.queryParam.subBeginTime = ''
        this.queryParam.subEndTime = ''
      }
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 选择省
    // 选择省
    onChangeProvince(e) {
      if (e.code) {
        this.queryParam.province = e.value
      } else {
        this.queryParam.province = ''
        this.queryParam.city = ''
        this.queryParam.area = ''
      }
    },
    // 选择市
    onChangeCity(e) {
      if (e.code) {
        this.queryParam.city = e.value
      } else {
        this.queryParam.city = ''
        this.queryParam.area = ''
      }
    },
    // 选择区
    onChangeArea(e) {
      if (e.code) {
        this.queryParam.area = e.value
      } else {
        this.queryParam.area = ''
      }
    },
    // 查区域
    getQu() {
      regionList({ pageNum: 1, pageSize: 9999, type: 1 }).then((res) => {
        this.listRegion = res.data
      })
    },
    /** 查询部门列表 */
    getList() {
      this.loading = true
      fetchList(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    // 下载验收报告
    handleLookDown(e, type) {
      acceptanceReport({ id: e.id, forceRegenerate: type }).then((res) => {
        // console.log(res,'resresres');
        // this.$message.success('下载成功')
        window.open(this.$url + res.data)
      })
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      const status = this.queryParam.status
      const acceptStatus = this.queryParam.acceptStatus
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        postCode: undefined,
        postName: undefined,
        status: undefined,
        regionId: undefined,
        orderType: undefined,
        tenantAgentId: undefined,
        tenantId: undefined,
      }
      this.value = []
      // 清除经销商选择显示
      this.selectedAgentName = ''
      this.selectedAgentKeys = []
      this.selectedAgent = null
      // 清除分销商选择显示
      this.selectedDistributorName = ''
      this.selectedDistributorKeys = []
      this.selectedDistributor = null
      if (this.orderType) {
        this.queryParam.orderType = this.orderType
      } else {
      }
      if (this.tenantId) {
        this.queryParam.tenantId = this.tenantId
        // this.queryParam.status = 7
      }
      if (this.regionId) {
        this.queryParam.regionId = this.regionId
        // this.queryParam.status = 7
      }
      if (this.tenantFirmId) {
        this.queryParam.tenantFirmId = this.tenantFirmId
        this.queryParam.status = this.status
        // this.queryParam.status = 7
      }
      this.queryParam.status = status
      this.queryParam.acceptStatus = acceptStatus
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    // 禁用启用
    handleDeletes(row) {
      var that = this
      // let ids = []
      // if (row.id) {
      //   ids = [row.id]
      // } else {
      //   ids = this.ids
      // }
      const text = '是否要作废此订单?'
      this.$confirm({
        title: text,
        onOk() {
          return statusObj({ id: row.id }).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.getStatus()
            that.$message.success('操作成功', 3)
          })
        },
        onCancel() { },
      })
    },
    // 重新发送短信
    handleSendSms(row) {
      var that = this
      this.$confirm({
        title: '是否要重新发送短信?',
        onOk() {
          return sendSms({ id: row.id }).then(() => {
            that.getList()
            that.$message.success('操作成功', 3)
          })
        },
        onCancel() { },
      })
    },
    // 重新生成验收报告
    handleRegenerate(row, type) {
      var that = this
      this.$confirm({
        title: '是否要重新生成验收报告?',
        onOk() {
          return that.handleLookDown(row, type)
        },
        onCancel() { },
      })
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      let ids = []
      if (row.id) {
        ids = [row.id]
      } else {
        ids = this.ids
      }
      this.$confirm({
        title: '是否要作废此订单?',
        onOk() {
          return orderVoid({ id: row.id }).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.getStatus()
            that.$message.success('操作成功', 3)
          })
        },
        onCancel() { },
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      const query = JSON.parse(JSON.stringify(that.queryParam))
      query.validCode = '0'
      query.validCodeReqNo = '0'
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download('fix/order/export', query, `订单信息.xlsx`)
        },
        onCancel() { },
      })
    },
  },
}
</script>
<style lang="less" scoped>
.ant-table {
  table-layout: fixed;
}

.text-ellipsis {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}
</style>
